import BaseModel from './base_model';

// App.Models.NewsletterType
export default BaseModel.extend({
  modelClass: "NewsletterType"
});
